export default __webpack_public_path__ + "static/media/woman-testing-at-home.f26b3406.svg";